// extracted by mini-css-extract-plugin
module.exports = {"container":"GameEndPicture_container__1H2_9","picture":"GameEndPicture_picture__3EUbC"};